import { render } from "./TheHeader.vue?vue&type=template&id=5b092e7a&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=5b092e7a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b092e7a"]])

export default __exports__